export default __webpack_public_path__ + "static/wedges-47525732ca350d702d3dfc747c1b6df5.png";